import React, { useState } from "react";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import { FaEye, FaLightbulb, FaShieldAlt, FaHandshake, FaBullseye, FaWhatsapp } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import NewsletterForm from "../components/NewsletterForm";

// Reusable value item with toggleable message
const ValueItem = ({ icon: Icon, title, message }) => {
  const [open, setOpen] = useState(false);
  const panelId = `${title.replace(/\s+/g, '-').toLowerCase()}-value`;
  return (
    <div className="bg-brand-50 border border-brand-100 rounded-lg p-3 text-center">
      <button
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => v ^ 1)}
        className="w-full outline-none focus:ring-2 focus:ring-brand-300 rounded-lg"
        title={open ? `Hide ${title}` : `Show ${title}`}
      >
        <Icon className="mx-auto text-brand-600 mb-1" />
        <div className="font-medium text-brand-900">{title}</div>
        <FiChevronDown className={`mx-auto mt-1 text-brand-700 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
      <div
        id={panelId}
        className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-40 opacity-100 mt-2' : 'max-h-0 opacity-0'}`}
      >
        <p className="text-xs text-gray-700 px-1">{message}</p>
      </div>
    </div>
  );
};

const About = () => {
  return (
    <main className="pt-24 text-brand-800 bg-white min-h-screen route-enter">
      <Navbar />

      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="w-full h-full bg-gradient-to-b from-brand-900 to-brand-700" />
        </div>
        <div className="relative max-w-6xl mx-auto px-6 py-16 md:py-20 grid md:grid-cols-2 gap-8 items-center text-white">
          <div>
            {/*<p className="uppercase tracking-widest text-brand-200 text-xs mb-2">Gesingo Security Technology </p>*/}
            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4">About Us</h1>
            <p className="text-brand-100 max-w-xl">
              We are a premier security technology provider, delivering cutting-edge surveillance, access control, and
              integrated security solutions to protect what matters most to you.
            </p>
          </div>
          {/* Hero image placeholder */}
          <div className="relative">
            <div className="rounded-[2rem] border-4 border-brand-accent bg-white/5 h-64 md:h-80 w-full overflow-hidden flex items-center justify-center">
                <img
                    src="/images/about.png"
                    alt="Contact Gesingo Security Technology"
                    className="w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                />
            </div>
          </div>
        </div>
      </section>

      {/* Metrics */}
      {/*<section className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-3 gap-4 text-center">*/}
      {/*  <div className="bg-brand-50 rounded-xl p-6">*/}
      {/*    <div className="text-3xl font-extrabold text-brand-900">10y</div>*/}
      {/*    <p className="text-sm text-gray-600">Experience</p>*/}
      {/*  </div>*/}
      {/*  <div className="bg-brand-50 rounded-xl p-6">*/}
      {/*    <div className="text-3xl font-extrabold text-brand-900">100+</div>*/}
      {/*    <p className="text-sm text-gray-600">Team members</p>*/}
      {/*  </div>*/}
      {/*  <div className="bg-brand-50 rounded-xl p-6">*/}
      {/*    <div className="text-3xl font-extrabold text-brand-900">1k</div>*/}
      {/*    <p className="text-sm text-gray-600">Projects</p>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/* Why choose us (cards) */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <p className="text-xs font-semibold tracking-wider text-brand-600 uppercase mb-2">Gesingo</p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-brand-950 mb-3">Why choose us?</h2>
        <p className="text-gray-600 max-w-3xl">
          Whether you need a simple home security setup or a complex commercial surveillance system, we bring
          professional expertise, reliable service, and a commitment to your safety.
        </p>

        <div className="mt-8 grid md:grid-cols-2 gap-4">

          <div className="bg-white rounded-xl border border-brand-100 shadow p-5 flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-brand-100 grid place-items-center text-brand-700">★</div>
            <div>
              <h3 className="font-semibold">Tailored Security Solutions</h3>
              <p className="text-sm text-gray-600">Customized systems designed for your specific property needs.</p>
            </div>
          </div>
          <div className="bg-white rounded-xl border border-brand-100 shadow p-5 flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-brand-100 grid place-items-center text-brand-700">✓</div>
            <div>
              <h3 className="font-semibold">Advanced Technology</h3>
              <p className="text-sm text-gray-600">Leveraging the latest in AI-powered surveillance and smart access control.</p>
            </div>
          </div>
          <div className="bg-white rounded-xl border border-brand-100 shadow p-5 flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-brand-100 grid place-items-center text-brand-700">❤</div>
            <div>
              <h3 className="font-semibold">Professional Support</h3>
              <p className="text-sm text-gray-600">Expert installation and dedicated maintenance services.</p>
            </div>
          </div>
            <div className="bg-white rounded-xl border border-brand-100 shadow p-5 flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-brand-100 grid place-items-center text-brand-700">$</div>
                <div>
                    <h3 className="font-semibold">Transparent Pricing</h3>
                    <p className="text-sm text-gray-600">No hidden fees. Clear, honest quotes for all services.</p>
                </div>
            </div>
        </div>
      </section>

      {/* Our story + keep same info from Home About */}
      <section className="max-w-6xl mx-auto px-6 pb-12 grid md:grid-cols-2 gap-8 items-start">
        <div className="relative">
        <div className="rounded-[2rem] border-4 border-brand-300 bg-white/5 h-64 md:h-80 w-full overflow-hidden">
            <img
                src="/images/image1.png"
                alt="About Gesingo Security Technology"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
            />
        </div>
      </div>
        <div>
          <p className="text-xs font-semibold tracking-wider text-brand-600 uppercase mb-2">Gesingo</p>
          <h3 className="text-3xl font-extrabold text-brand-950 mb-3">Our story</h3>
          <p className="text-gray-700 mb-5">
            Founded with a vision to provide superior protection through innovation, we combine technical
            expertise with the latest security technologies to safeguard homes, businesses, and communities.
          </p>

          {/* Content mirrored from Home.jsx About section */}
          <div className="space-y-6">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <FaEye className="text-brand-600" />
                <h4 className="font-semibold text-brand-800">Our Vision</h4>
              </div>
              <p className="text-sm text-gray-700">
                To be the most trusted provider of advanced security technology solutions in the country.
              </p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-2">
                <FaBullseye className="text-brand-600" />
                <h4 className="font-semibold text-brand-800">Our Mission</h4>
              </div>
              <p className="text-sm text-gray-700">
                To provide innovative, reliable, and integrated security services that ensure complete peace of mind for our clients.
              </p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-2">
                <FaHandshake className="text-brand-600" />
                <h4 className="font-semibold text-brand-800">Core Values</h4>
              </div>
              <div className="grid sm:grid-cols-3 gap-3 text-sm">
                <ValueItem
                  icon={FaLightbulb}
                  title="Innovation"
                  message="Adopting the latest tech to stay ahead of threats."
                />
                <ValueItem
                  icon={FaShieldAlt}
                  title="Reliability"
                  message="Building trust through consistent and quality service."
                />
                <ValueItem
                  icon={FaHandshake}
                  title="Integrity"
                  message="Operating with transparency and honesty in all dealings."
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Showcase Section */}
      <section className="py-20 bg-brand-50/30">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-brand-950 mb-4">Our Completed Projects</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">We take pride in delivering high-quality security technology installations tailored to our clients' needs.</p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Work 1 */}
            <Link to="/works/work1" className="group bg-white rounded-2xl overflow-hidden border border-brand-100 shadow-sm hover:shadow-md transition">
              <div className="aspect-[4/3] w-full overflow-hidden bg-brand-100">
                <img src="/images/work1.png" alt="Project 1" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
              </div>
              <div className="p-5">
                <h3 className="font-bold text-brand-900">Commercial Security Setup</h3>
                <p className="text-xs text-brand-600 font-semibold uppercase tracking-wider mb-2">CCTV & Access Control</p>
                <p className="text-sm text-gray-600">Integrated security solution for a multi-story office building.</p>
              </div>
            </Link>

            {/* Work 2 */}
            <Link to="/works/work2" className="group bg-white rounded-2xl overflow-hidden border border-brand-100 shadow-sm hover:shadow-md transition">
              <div className="aspect-[4/3] w-full overflow-hidden bg-brand-100">
                <img src="/images/work2.png" alt="Project 2" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
              </div>
              <div className="p-5">
                <h3 className="font-bold text-brand-900">Residential Protection</h3>
                <p className="text-xs text-brand-600 font-semibold uppercase tracking-wider mb-2">Electric Fencing</p>
                <p className="text-sm text-gray-600">Premium perimeter security for a private residence.</p>
              </div>
            </Link>

            {/* Work 3 */}
            <Link to="" className="group bg-white rounded-2xl overflow-hidden border border-brand-100 shadow-sm hover:shadow-md transition">
              <div className="aspect-[4/3] w-full overflow-hidden bg-brand-100">
                <img src="/images/gate1.png" alt="Gate Automation" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
              </div>
              <div className="p-5">
                <h3 className="font-bold text-brand-900">Gate Automation</h3>
                <p className="text-xs text-brand-600 font-semibold uppercase tracking-wider mb-2">Gate Automation</p>
                <p className="text-sm text-gray-600">Smart sliding gate installation for residential properties.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter (same as Service/Contact) */}
      <section className="bg-gradient-to-br from-brand-900 to-brand-800 text-white">
        <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-[1fr_auto] gap-6 items-center">
          <div>
            <h3 className="text-2xl font-semibold mb-1">Our Newsletters</h3>
            <p className="text-brand-100 max-w-xl">Subscribe to receive updates about our services and initiatives.</p>
          </div>
          <NewsletterForm />
        </div>
      </section>

      {/* Footer stripe (same look as Service) */}
      <section className="bg-brand-50">
        <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8 bg-white rounded-2xl shadow-sm">
          <div className="space-y-3">
            <img src="/images/logo.png" alt="Gesingo Security Technology logo" className="h-12 w-12 object-contain rounded" />
              <p className="text-gray-600 text-sm">
              Providing advanced security technology solutions and expert technical services to safeguard your environment.
          </p>
          </div>
          <div className="col-span-3 grid sm:grid-cols-2 gap-6 text-sm text-gray-700">
            <div>
              <div className="font-semibold mb-2">Navigation</div>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:underline">Home</Link></li>
                <li><Link to="/about" className="hover:underline">About</Link></li>
                <li><Link to="/services" className="hover:underline">Services</Link></li>
                <li><Link to="/contact" className="hover:underline">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-semibold mb-2">Work Hours</div>
              <ul className="space-y-2">
                <li>7:30AM – 5:30PM, Mon–Sun</li>
                <li className="text-gray-500">Closed on Fridays</li>
              </ul>
              <div className="mt-4 flex items-center gap-3">
                <a href="tel:+233244844226">
                  <button type="button" className="inline-flex px-4 py-2 rounded-full bg-brand-600 text-white hover:bg-brand-700">Call Us</button>
                </a>
                <a
                  href="https://wa.me/233504869983"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-500 text-white hover:bg-brand-600 shadow"
                >
                  <FaWhatsapp className="text-lg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="text-center text-gray-500 text-sm py-6">
        <p>© {new Date().getFullYear()} Gesingo Security Technology</p>
        <p className="mt-1">Designed by <a href="https://wa.me/233545038856" className="text-brand-600 hover:underline" target="_blank" rel="noopener noreferrer">WASS TECH SOLUTIONS</a></p>
      </footer>
    </main>
  );
};

export default About;
